import React from "react";
import { View } from "react-native";
import { uniqueId } from "lodash";
import Svg, { Path, Defs, Rect, G, ClipPath } from "react-native-svg";

export default function TrackEmptyPageIcon(props) {
  const filterId = "clip0" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";

  return (
    <View style={props.style} {...props}>
      <Svg
        width="238"
        height="197"
        viewBox="0 0 238 197"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath={filterUrl}>
          <Path
            d="M177.217 188.662C184.716 194.474 194.139 197.228 203.588 196.37C213.037 195.513 221.81 191.108 228.141 184.041C234.472 176.975 237.891 167.773 237.709 158.287C237.528 148.801 233.759 139.736 227.162 132.917L177.217 188.662Z"
            fill="#F2F2F2"
          />
          <Path
            d="M85.4589 58.4612L39.0918 109.575C41.6221 115.074 45.4408 119.882 50.2242 123.592L100.17 67.8472C96.0715 63.6064 91.0317 60.3908 85.4589 58.4612Z"
            fill="#F2F2F2"
          />
          <Path
            d="M85.2734 58.488V28.5994H60.8721V58.3956C68.791 55.719 77.375 55.7515 85.2734 58.488Z"
            fill="#239C9D"
          />
          <Path
            d="M60.8721 128.944V159.527H85.2734V128.851C77.375 131.588 68.791 131.62 60.8721 128.944Z"
            fill="#239C9D"
          />
          <Path
            d="M73.2043 131.321C52.4432 131.321 35.5527 114.431 35.5527 93.6696C35.5527 72.9085 52.4432 56.0181 73.2043 56.0181C93.9653 56.0181 110.856 72.9085 110.856 93.6696C110.856 114.431 93.9653 131.321 73.2043 131.321ZM73.2043 56.2804C52.5878 56.2804 35.8151 73.0532 35.8151 93.6696C35.8151 114.286 52.5878 131.059 73.2043 131.059C93.8207 131.059 110.593 114.286 110.593 93.6696C110.593 73.0532 93.8207 56.2804 73.2043 56.2804Z"
            fill="black"
          />
          <Path
            d="M46.7031 93.6693C46.7031 100.698 49.4951 107.438 54.4649 112.408C59.4347 117.378 66.1752 120.17 73.2035 120.17V67.1689C66.1752 67.1689 59.4347 69.9609 54.4649 74.9307C49.4951 79.9005 46.7031 86.641 46.7031 93.6693Z"
            fill="#575A89"
          />
          <Path
            d="M73.2041 67.1689V120.17C80.2324 120.17 86.9729 117.378 91.9427 112.408C96.9125 107.438 99.7045 100.698 99.7045 93.6693C99.7045 86.641 96.9125 79.9005 91.9427 74.9307C86.9729 69.9609 80.2324 67.1689 73.2041 67.1689Z"
            fill="#239C9D"
          />
          <Path
            d="M73.2026 98.6547C75.2313 98.6547 76.8759 97.0101 76.8759 94.9814C76.8759 92.9527 75.2313 91.3081 73.2026 91.3081C71.1739 91.3081 69.5293 92.9527 69.5293 94.9814C69.5293 97.0101 71.1739 98.6547 73.2026 98.6547Z"
            fill="#2F2E41"
          />
          <Path
            d="M73.1976 81.5105L74.1127 88.7708L75.0279 96.0311H73.1976H71.3672L72.2824 88.7708L73.1976 81.5105Z"
            fill="#2F2E41"
          />
          <Path
            d="M95.1053 95.1879L83.1638 95.6345L71.2227 96.0808L71.2292 95.0378L71.2358 93.9946L83.1704 94.5913L95.1053 95.1879Z"
            fill="#2F2E41"
          />
          <Path
            d="M112.167 96.8181C111.56 96.8181 111.314 96.4007 111.004 95.8723C110.926 95.7404 110.842 95.5973 110.745 95.446L110.966 95.304C111.065 95.4585 111.151 95.6046 111.23 95.7394C111.539 96.2658 111.71 96.5557 112.167 96.5557C113.686 96.5557 114.922 94.0251 114.922 90.9145C114.922 87.804 113.686 85.2734 112.167 85.2734C111.29 85.2734 110.68 85.8145 110.19 87.028L109.946 86.9296C110.483 85.6028 111.167 85.011 112.167 85.011C113.831 85.011 115.184 87.6593 115.184 90.9145C115.184 94.1698 113.831 96.8181 112.167 96.8181Z"
            fill="black"
          />
          <Path
            d="M76.8761 187.339C96.5836 187.339 112.56 186.752 112.56 186.027C112.56 185.303 96.5836 184.716 76.8761 184.716C57.1685 184.716 41.1924 185.303 41.1924 186.027C41.1924 186.752 57.1685 187.339 76.8761 187.339Z"
            fill="#F2F2F2"
          />
          <Path
            d="M203.081 47.4909C206.124 47.4909 208.591 45.024 208.591 41.9809C208.591 38.9378 206.124 36.4709 203.081 36.4709C200.038 36.4709 197.571 38.9378 197.571 41.9809C197.571 45.024 200.038 47.4909 203.081 47.4909Z"
            fill="#F2F2F2"
          />
          <Path
            d="M37.5203 1.5597e-05C31.2321 0.00234318 25.0453 1.58447 19.5279 4.60112C14.0105 7.61777 9.33947 11.9723 5.94366 17.2647C2.54785 22.5572 0.536131 28.618 0.093227 34.8906C-0.349677 41.1632 0.790434 47.4465 3.40886 53.1636L49.7759 2.04948C45.8333 0.68889 41.6911 -0.00379014 37.5203 1.5597e-05Z"
            fill="#F2F2F2"
          />
          <Path
            d="M162.186 69.7135C166.713 69.7135 170.382 66.044 170.382 61.5174C170.382 56.9908 166.713 53.3213 162.186 53.3213C157.66 53.3213 153.99 56.9908 153.99 61.5174C153.99 66.044 157.66 69.7135 162.186 69.7135Z"
            fill="#2F2E41"
          />
          <Path
            d="M148.397 112.898C148.397 112.898 154.941 129.429 155.63 129.429C156.319 129.429 157.352 123.23 157.352 123.23L153.219 111.52L148.397 112.898Z"
            fill="#FFB9B9"
          />
          <Path
            d="M158.041 67.78C158.041 67.78 159.763 75.0126 159.074 76.3903C158.385 77.7679 160.452 79.8343 160.452 79.8343H165.274L168.718 74.3238L169.407 71.9129C169.407 71.9129 167.34 66.4024 167.684 65.7136C168.029 65.0248 158.041 67.78 158.041 67.78Z"
            fill="#FFB9B9"
          />
          <Path
            opacity="0.1"
            d="M158.041 67.78C158.041 67.78 159.763 75.0126 159.074 76.3903C158.385 77.7679 160.452 79.8343 160.452 79.8343H165.274L168.718 74.3238L169.407 71.9129C169.407 71.9129 167.34 66.4024 167.684 65.7136C168.029 65.0248 158.041 67.78 158.041 67.78Z"
            fill="black"
          />
          <Path
            d="M177.328 184.879V188.668L181.805 189.701L182.15 184.879H177.328Z"
            fill="#575A89"
          />
          <Path
            d="M159.074 117.031C159.074 117.031 154.252 125.641 155.974 130.118C157.696 134.595 164.24 156.638 164.24 156.638C164.24 156.638 168.028 169.036 168.028 169.725C168.028 170.414 171.128 185.568 172.161 185.912C173.195 186.257 182.494 187.29 182.838 186.257C183.182 185.224 183.527 179.713 182.494 178.68C181.46 177.647 175.95 145.617 175.95 145.617L175.261 134.94L183.871 161.459C183.871 161.459 186.282 177.302 187.315 178.335C188.349 179.369 185.249 180.402 186.282 181.435C187.315 182.468 191.104 185.224 190.759 186.257C190.415 187.29 199.025 187.29 200.058 186.601C201.092 185.912 200.747 175.236 200.747 175.236L195.926 160.771L190.415 125.641C190.415 125.641 188.693 115.309 187.315 115.309C185.938 115.309 159.074 117.031 159.074 117.031Z"
            fill="#2F2E41"
          />
          <Path
            d="M178.361 187.29C178.361 187.29 175.605 184.879 174.228 185.568C172.85 186.257 168.373 192.801 166.995 192.456C165.618 192.112 163.551 196.163 166.995 196.507C170.439 196.852 175.95 196.163 175.95 196.163C177.089 196.352 178.24 196.467 179.394 196.507C180.771 196.507 183.871 196.852 183.871 196.507C183.871 196.163 183.182 188.323 182.838 188.323C182.494 188.323 178.705 188.323 178.361 187.29Z"
            fill="#2F2E41"
          />
          <Path
            d="M197.304 184.879C197.304 184.879 193.859 184.19 193.515 184.879C193.171 185.568 191.793 187.634 191.793 187.979C191.793 188.323 192.482 192.456 192.482 192.801C192.482 193.145 193.171 194.178 193.859 194.867C194.054 195.032 194.192 195.253 194.254 195.5C194.316 195.747 194.298 196.008 194.204 196.245C194.204 196.245 203.158 197.278 203.158 195.9C203.158 194.523 202.125 191.423 201.436 190.734C200.748 190.045 199.37 185.224 197.304 184.879Z"
            fill="#2F2E41"
          />
          <Path
            d="M162.174 70.8797C166.168 70.8797 169.407 67.6416 169.407 63.6471C169.407 59.6527 166.168 56.4146 162.174 56.4146C158.18 56.4146 154.941 59.6527 154.941 63.6471C154.941 67.6416 158.18 70.8797 162.174 70.8797Z"
            fill="#FFB9B9"
          />
          <Path
            d="M159.419 76.7353C159.419 76.7353 163.552 79.1461 165.963 75.3576C168.374 71.5691 175.951 82.9346 175.951 82.9346L178.017 118.064C178.017 118.064 174.229 118.409 167.685 120.131C161.141 121.853 158.041 117.72 158.041 117.72L157.697 97.7442L158.386 88.4452L157.353 80.8682L158.041 76.3909L159.419 76.7353Z"
            fill="#239C9D"
          />
          <Path
            d="M151.842 81.2122C151.842 81.2122 149.086 81.901 148.398 86.7227C147.709 91.5444 146.331 106.01 146.331 106.01L148.053 114.62C148.053 114.62 152.875 110.831 154.597 112.553L153.564 107.387L154.597 104.288L151.497 90.8556L151.842 81.2122Z"
            fill="#239C9D"
          />
          <Path
            d="M158.691 70.8799C158.691 70.8799 158.04 70.8799 158.04 73.2907C158.04 75.7016 151.496 79.1457 151.496 79.1457C151.496 79.1457 150.808 80.1789 150.808 82.9342C150.808 85.6895 150.808 92.2332 151.496 94.2997C152.185 96.3661 153.218 103.254 153.563 103.943C153.907 104.632 153.907 107.732 153.218 108.42C152.53 109.109 154.941 113.242 155.629 113.587C156.318 113.931 153.218 122.886 154.941 123.23C156.663 123.574 159.762 119.097 160.795 116.686C161.829 114.275 161.14 80.8678 160.795 78.4569C160.451 76.046 158.691 70.8799 158.691 70.8799Z"
            fill="#575A89"
          />
          <Path
            d="M168.286 68.6634C168.286 68.6634 168.028 67.0913 169.75 68.469C171.472 69.8466 171.817 70.8798 171.817 70.8798C171.817 70.8798 180.771 70.8798 181.116 71.9131C181.46 72.9463 180.911 81.7391 180.911 81.7391L185.437 98.5669C185.437 98.5669 191.793 118.064 192.481 118.753C193.17 119.441 186.971 115.653 183.527 118.408C180.083 121.163 173.883 122.541 173.194 120.819C172.506 119.097 164.929 79.1456 164.929 79.1456C164.929 79.1456 164.929 72.6019 165.962 71.9131C166.995 71.2242 168.286 68.6634 168.286 68.6634Z"
            fill="#575A89"
          />
          <Path
            d="M186.627 101.188L185.25 117.03L184.905 118.408L190.071 125.296C190.071 125.296 191.105 121.508 190.76 120.13C190.416 118.752 192.482 103.254 192.482 103.254L186.627 101.188Z"
            fill="#FFB9B9"
          />
          <Path
            d="M156.511 58.5059C156.511 58.5059 154.837 54.1551 157.264 52.7328L157.933 54.6571C157.933 54.6571 164.041 50.9757 165.63 51.8124L164.124 53.8205C164.124 53.8205 171.236 53.8205 171.738 56.5815L169.228 56.6652C169.228 56.6652 171.905 58.4222 171.989 61.2669L166.634 61.6016L169.228 63.1076C169.228 63.1076 159.523 64.4463 157.18 60.5976L156.511 58.5059Z"
            fill="#2F2E41"
          />
          <Path
            d="M155.062 58.6783C155.062 58.6783 156.99 62.5353 159.561 61.571C162.133 60.6068 159.561 57.0712 159.561 57.0712L157.847 56.2141L155.062 58.6783Z"
            fill="#2F2E41"
          />
          <Path
            d="M216.988 196.391H141.947V196.654H216.988V196.391Z"
            fill="black"
          />
          <Path
            d="M180.427 72.6021C180.427 72.6021 182.493 72.9465 183.871 75.3573C185.248 77.7682 192.137 93.611 192.481 94.2998C192.825 94.9886 192.825 104.288 192.825 104.288C192.825 104.288 188.004 101.532 185.937 103.254L185.593 99.1215L181.116 83.2787L180.427 78.1126L180.427 72.6021Z"
            fill="#239C9D"
          />
        </G>
        <Defs>
          <ClipPath id={filterId}>
            <Rect width="237.716" height="196.66" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    </View>
  );
}
